<footer class="navbar fixed-bottom bg-light">
  <span class="navbar-text ms-1 mr-auto">{{
    displayName ? displayName : '&nbsp;'
  }}</span>
  <span class="navbar-text me-1" role="button">
    <a (click)="logout()">Sign Out</a>
  </span>
</footer>
